<template>
  <div>
    <div class="wrapper">
      <input type="radio" name="contrato" id="contrato-1" @click="selectedTipoContrato('Planta')"/>
      <input type="radio" name="contrato" id="contrato-2" @click="selectedTipoContrato('Contrata')"/>
      <input type="radio" name="contrato" id="contrato-3" @click="selectedTipoContrato('Honorarios')"/>
      <input type="radio" name="contrato" id="contrato-4" @click="selectedTipoContrato('Reemplazo')"/>
      <input type="radio" name="contrato" id="contrato-5" @click="selectedTipoContrato('Planta,Contrata,Honorarios,Reemplazo')"/>

      <label for="contrato-1" class="contrato contrato-1">
        <div class="dot"></div>
        <span>Planta</span>
      </label>
      <label for="contrato-2" class="contrato contrato-2">
        <div class="dot"></div>
        <span>Contrata</span>
      </label>
      <label for="contrato-3" class="contrato contrato-3">
        <div class="dot"></div>
        <span>Honorarios</span>
      </label>
      <label for="contrato-4" class="contrato contrato-4">
        <div class="dot"></div>
        <span>Reemplazo</span>
      </label>
      <label for="contrato-5" class="contrato contrato-5">
        <div class="dot"></div>
        <span>Todos</span>
      </label>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    selectedTipoContrato: function(selected) {
      this.$store.commit("setRHTipoContrato", selected)
    }
  }
}
</script>
<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Fira+Sans:wght@300;400;600&display=swap");
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Fira Sans", sans-serif;
}
html,
body {
  display: grid;
  place-items: center;
  background: #0069d9;
  font-family: "Fira Sans", sans-serif;
}
.wrapper {
  background: #fff;
  height: 80px;
  border-radius: 5px;
  display: inline-flex;
  align-items: center;
}
.wrapper .contrato {
  background: #e0e0e0;
  height: 50px;
  width: 170px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
  cursor: pointer;
  border: none;
  transition: all 0.3s ease;
  margin-right: 15px;
}

.wrapper .contrato .dot::before {
  position: absolute;
  content: "";
  top: 4px;
  left: 4px;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  opacity: 0;
  transform: scale(1.5);
  transition: all 0.3s ease;
}
input[type="radio"] {
  display: none;
}
#contrato-1:checked:checked ~ .contrato-1,
#contrato-2:checked:checked ~ .contrato-2,
#contrato-3:checked:checked ~ .contrato-3,
#contrato-4:checked:checked ~ .contrato-4,
#contrato-5:checked:checked ~ .contrato-5,
#contrato-6:checked:checked ~ .contrato-6 {
  border-color: #24c6ab;
  background: #24c6ab;
}
#contrato-1:checked:checked ~ .contrato-1 .dot,
#contrato-2:checked:checked ~ .contrato-2 .dot,
#contrato-3:checked:checked ~ .contrato-3 .dot,
#contrato-4:checked:checked ~ .contrato-4 .dot,
#contrato-5:checked:checked ~ .contrato-5 .dot,
#contrato-6:checked:checked ~ .contrato-6 .dot {
  background: #fff;
}
#contrato-1:checked:checked ~ .contrato-1 .dot::before,
#contrato-2:checked:checked ~ .contrato-2 .dot::before,
#contrato-3:checked:checked ~ .contrato-3 .dot::before,
#contrato-4:checked:checked ~ .contrato-4 .dot::before,
#contrato-5:checked:checked ~ .contrato-5 .dot::before,
#contrato-6:checked:checked ~ .contrato-6 .dot::before {
  opacity: 1;
  transform: scale(1);
}

#contrato-1:checked:checked ~ .contrato-1 span,
#contrato-2:checked:checked ~ .contrato-2 span,
#contrato-3:checked:checked ~ .contrato-3 span,
#contrato-4:checked:checked ~ .contrato-4 span,
#contrato-5:checked:checked ~ .contrato-5 span,
#contrato-6:checked:checked ~ .contrato-6 span {
  color: #fff;
}

@media screen and (max-width: 1520px) {
  .wrapper .contrato {
    height: 40px;
    width: 120px;
    font-size: 14px;
  }
}

@media screen and (max-width: 1000px) {
    .wrapper .contrato {
    height: 30px;
    width: 90px;
    font-size: 10px;
  }
}

@media screen and (max-width: 770px) {
  .wrapper .contrato {
    height: 30px;
    width: 80px;
    font-size: 9px;
    margin-right: 10px;
  }
}
</style>
